
<div>
    <mat-form-field>
        <mat-label>Image URL</mat-label>
        <input matInput type="text" [(ngModel)]="imageUrl">

        <input #file type="file" style="display: none;">

        @if (data.stackEditor.allowImageUpload) {
            <button
                mat-flat-button

                (click)="file.click(); onFileUpload(file.files)"
                style="float: right"
            >
                <mat-icon>upload_file</mat-icon>
                Or upload an Image
            </button>
        }
    </mat-form-field>
</div>

<mat-form-field>
    <mat-label matTooltip="Text shown if the image fails to load">Placeholder Text</mat-label>
    <input matInput type="text" [(ngModel)]="imagePlaceholder">
</mat-form-field>

<div style="flex: 1"></div>

<div style="display: flex; justify-content: end;">
    <button mat-flat-button (click)="applyChanges()">

        @if (isSaving) {
            <mat-progress-spinner
                mode="indeterminate"
                [diameter]="18"
                style="display: inline"
            />
        }
        @else {
            <mat-icon>check</mat-icon>
        }

        Ok
    </button>
    <button
        mat-flat-button
        (click)="dialogRef.close()"
    >
        <mat-icon>close</mat-icon>
        Cancel
    </button>
</div>
